"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6485],{

/***/ 16050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var stitches_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50530);
/* harmony import */ var react_responsive_carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10615);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67731);
/* harmony import */ var react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_responsive_carousel_lib_styles_carousel_min_css__WEBPACK_IMPORTED_MODULE_3__);



 // requires a loader
const Box = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    maxWidth: "380px",
    width: "100%"
});
const Image = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("img", {
    width: "100%",
    maxHeight: "380px"
});
const ButtonBox = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("div", {
    paddingTop: "$4",
    paddingBottom: "$4"
});
const Text = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("p", {});
const Button1 = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("a", {
    outline: "none",
    fontWeight: 700,
    fontSize: 16,
    fontFamily: "$button",
    transition: "background-color 250ms linear",
    gap: "$space$2",
    display: "inline-flex",
    alignItems: "center",
    lineHeight: "20px",
    $$focusColor: "$colors$gray12",
    "&:focus-visible": {
        boxShadow: "0 0 0 2px $$focusColor"
    },
    "&:disabled": {
        backgroundColor: "$gray8",
        color: "$gray11"
    },
    "&:disabled:hover": {
        backgroundColor: "$gray8",
        color: "$gray11"
    },
    width: "100%",
    variants: {
        color: {
            primary: {
                backgroundColor: "$primary8",
                color: "white",
                "&:hover": {
                    backgroundColor: "#F4CC45"
                }
            },
            secondary: {
                backgroundColor: "$secondary4",
                color: "$primary12",
                "&:hover": {
                    backgroundColor: "$secondary5"
                }
            },
            gray3: {
                backgroundColor: "$gray3",
                color: "$gray12",
                "&:hover": {
                    backgroundColor: "$gray4"
                }
            },
            gray4: {
                backgroundColor: "$gray4",
                color: "$gray12",
                "&:hover": {
                    backgroundColor: "$gray5"
                }
            },
            ghost: {
                backgroundColor: "transparent",
                p: 0
            }
        },
        corners: {
            square: {
                borderRadius: 0
            },
            rounded: {
                borderRadius: 8,
                alignItems: "center",
                justifyContent: "center"
            },
            pill: {
                borderRadius: 99999
            },
            circle: {
                borderRadius: "99999px",
                alignItems: "center",
                justifyContent: "center"
            }
        },
        size: {
            none: {},
            xs: {
                p: "$space$3",
                lineHeight: "16px",
                minHeight: 40
            },
            small: {
                px: "$space$3",
                py: "$space$4",
                lineHeight: "12px",
                minHeight: 44
            },
            medium: {
                px: "$space$5",
                py: "$space$3",
                minHeight: 44
            },
            large: {
                px: "$space$5",
                py: "$space$4",
                minHeight: 52
            }
        }
    },
    compoundVariants: [
        {
            size: "xs",
            corners: "circle",
            css: {
                height: 40,
                width: 40,
                p: 0
            }
        },
        {
            size: "small",
            corners: "circle",
            css: {
                height: 44,
                width: 44,
                p: 0
            }
        },
        {
            size: "medium",
            corners: "circle",
            css: {
                height: 44,
                width: 44,
                p: 0
            }
        },
        {
            size: "large",
            corners: "circle",
            css: {
                height: 52,
                width: 52,
                p: 0
            }
        }
    ],
    defaultVariants: {
        color: "primary",
        corners: "rounded",
        size: "medium"
    }
});
const Button2 = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("a", {
    outline: "none",
    fontWeight: 700,
    fontSize: 16,
    fontFamily: "$button",
    transition: "background-color 250ms linear",
    gap: "$space$2",
    display: "inline-flex",
    alignItems: "center",
    lineHeight: "20px",
    $$focusColor: "$colors$gray12",
    "&:focus-visible": {
        boxShadow: "0 0 0 2px $$focusColor"
    },
    "&:disabled": {
        backgroundColor: "$gray8",
        color: "$gray11"
    },
    "&:disabled:hover": {
        backgroundColor: "$gray8",
        color: "$gray11"
    },
    width: "100%",
    variants: {
        color: {
            primary: {
                backgroundColor: "$primary8",
                color: "white",
                "&:hover": {
                    backgroundColor: "$primary10"
                }
            },
            secondary: {
                backgroundColor: "$secondary4",
                color: "$primary12",
                "&:hover": {
                    backgroundColor: "$secondary5"
                }
            },
            gray3: {
                backgroundColor: "$gray3",
                color: "$gray12",
                "&:hover": {
                    backgroundColor: "$gray4"
                }
            },
            gray4: {
                backgroundColor: "$gray4",
                color: "$gray12",
                "&:hover": {
                    backgroundColor: "$gray5"
                }
            },
            ghost: {
                backgroundColor: "transparent",
                p: 0
            }
        },
        corners: {
            square: {
                borderRadius: 0
            },
            rounded: {
                borderRadius: 8,
                alignItems: "center",
                justifyContent: "center"
            },
            pill: {
                borderRadius: 99999
            },
            circle: {
                borderRadius: "99999px",
                alignItems: "center",
                justifyContent: "center"
            }
        },
        size: {
            none: {},
            xs: {
                p: "$space$3",
                lineHeight: "16px",
                minHeight: 40
            },
            small: {
                px: "$space$3",
                py: "$space$4",
                lineHeight: "12px",
                minHeight: 44
            },
            medium: {
                minHeight: 44
            },
            large: {
                px: "$space$5",
                py: "$space$4",
                minHeight: 52
            }
        }
    },
    compoundVariants: [
        {
            size: "xs",
            corners: "circle",
            css: {
                height: 40,
                width: 40,
                p: 0
            }
        },
        {
            size: "small",
            corners: "circle",
            css: {
                height: 44,
                width: 44,
                p: 0
            }
        },
        {
            size: "medium",
            corners: "circle",
            css: {
                height: 44,
                width: 44,
                p: 0
            }
        },
        {
            size: "large",
            corners: "circle",
            css: {
                height: 52,
                width: 52,
                p: 0
            }
        }
    ],
    defaultVariants: {
        color: "primary",
        corners: "rounded",
        size: "medium"
    }
});
const Button3 = (0,stitches_config__WEBPACK_IMPORTED_MODULE_1__/* .styled */ .zo)("a", {
    outline: "none",
    fontWeight: 700,
    fontSize: 16,
    fontFamily: "$button",
    transition: "background-color 250ms linear",
    gap: "$space$2",
    display: "inline-flex",
    alignItems: "center",
    lineHeight: "20px",
    $$focusColor: "$colors$gray12",
    "&:focus-visible": {
        boxShadow: "0 0 0 2px $$focusColor"
    },
    "&:disabled": {
        backgroundColor: "$gray8",
        color: "$gray11"
    },
    "&:disabled:hover": {
        backgroundColor: "$gray8",
        color: "$gray11"
    },
    width: "100%",
    variants: {
        color: {
            primary: {
                backgroundColor: "#3B66F5",
                color: "white",
                "&:hover": {
                    backgroundColor: "#6CCBFA"
                }
            },
            secondary: {
                backgroundColor: "$secondary4",
                color: "$primary12",
                "&:hover": {
                    backgroundColor: "$secondary5"
                }
            },
            gray3: {
                backgroundColor: "$gray3",
                color: "$gray12",
                "&:hover": {
                    backgroundColor: "$gray4"
                }
            },
            gray4: {
                backgroundColor: "$gray4",
                color: "$gray12",
                "&:hover": {
                    backgroundColor: "$gray5"
                }
            },
            ghost: {
                backgroundColor: "transparent",
                p: 0
            }
        },
        corners: {
            square: {
                borderRadius: 0
            },
            rounded: {
                borderRadius: 8,
                alignItems: "center",
                justifyContent: "center"
            },
            pill: {
                borderRadius: 99999
            },
            circle: {
                borderRadius: "99999px",
                alignItems: "center",
                justifyContent: "center"
            }
        },
        size: {
            none: {},
            xs: {
                p: "$space$3",
                lineHeight: "16px",
                minHeight: 40
            },
            small: {
                px: "$space$3",
                py: "$space$4",
                lineHeight: "12px",
                minHeight: 44
            },
            medium: {
                px: "$space$5",
                py: "$space$3",
                minHeight: 44
            },
            large: {
                px: "$space$5",
                py: "$space$4",
                minHeight: 52
            }
        }
    },
    compoundVariants: [
        {
            size: "xs",
            corners: "circle",
            css: {
                height: 40,
                width: 40,
                p: 0
            }
        },
        {
            size: "small",
            corners: "circle",
            css: {
                height: 44,
                width: 44,
                p: 0
            }
        },
        {
            size: "medium",
            corners: "circle",
            css: {
                height: 44,
                width: 44,
                p: 0
            }
        },
        {
            size: "large",
            corners: "circle",
            css: {
                height: 52,
                width: 52,
                p: 0
            }
        }
    ],
    defaultVariants: {
        color: "primary",
        corners: "rounded",
        size: "medium"
    }
});
function Card(param) {
    let { headline , description , carouselImages , button1Link , button1Text , button2Link , button2Text , button3Link , button3Text  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Box, {
        css: {
            zIndex: "2",
            borderWidth: 0,
            borderColor: "#9362F6",
            borderRadius: "$3",
            overflow: "hidden"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_carousel__WEBPACK_IMPORTED_MODULE_2__/* .Carousel */ .lr, {
                showThumbs: false,
                children: carouselImages === null || carouselImages === void 0 ? void 0 : carouselImages.map((image, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Image, {
                            src: image
                        })
                    }, index))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Box, {
                css: {
                    p: "$4"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        as: "h2",
                        css: {
                            fontFamily: "Luckiest Guy, cursive",
                            fontWeight: "normal",
                            mb: "$2",
                            fontSize: "28px"
                        },
                        children: headline
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Text, {
                        as: "p",
                        children: description
                    }),
                    button1Link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonBox, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button1, {
                            css: {
                                zIndex: "99999",
                                background: "$btn2",
                                color: "#5A1CDA",
                                fontFamily: "Luckiest Guy, cursive",
                                fontSize: "1.5rem",
                                fontWeight: 100,
                                letterSpacing: "1px",
                                textTransform: "uppercase"
                            },
                            href: button1Link,
                            children: button1Text
                        })
                    }),
                    button2Link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonBox, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button2, {
                            css: {
                                zIndex: "99999",
                                background: "$btn1",
                                color: "#FFFFFF",
                                fontFamily: "Luckiest Guy, cursive",
                                fontSize: "1.5rem",
                                fontWeight: 100,
                                letterSpacing: "1px",
                                textTransform: "uppercase"
                            },
                            href: button2Link,
                            children: button2Text
                        })
                    }),
                    button3Link && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonBox, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Button3, {
                            css: {
                                zIndex: "99999",
                                background: "$btn3",
                                color: "#FFFFFF",
                                fontFamily: "Luckiest Guy, cursive",
                                fontSize: "1.5rem",
                                fontWeight: 100,
                                letterSpacing: "1px",
                                textTransform: "uppercase"
                            },
                            href: button3Link,
                            children: button3Text
                        })
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 4049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


/**
 * Renders the <head> section of the HTML page, including meta tags, title, and favicon.
 * @param ogImage - The URL of the Open Graph image to be displayed in social media shares.
 * @param title - The title of the page.
 * @param description - The description of the page.
 */ const Head = (param)=>{
    let { ogImage ="https://hunnys.io/wp-content/uploads/2022/11/Hunnys-Banner-Large-2.png" , title ="Shop Hunnys NFTs" , description ="The Official Multichain Hunnys Marketplace for all Hunnys NFTs."  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: "@hunnysNFT"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: ogImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:determiner",
                content: "the"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: "en"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: ogImage
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:type",
                content: "image/png"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:height",
                content: "630"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:alt",
                content: "Hunnys Banner"
            })
        ]
    });
};


/***/ }),

/***/ 53593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _primitives__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21666);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99603);
/* harmony import */ var _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93024);





const SectionTitle = (param)=>/*#__PURE__*/ {
    let { title  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
        style: "subtitle1",
        css: {
            color: "$gray12",
            mb: 8,
            fontFamily: "Luckiest Guy, cursive",
            fontSize: "2rem",
            fontWeight: 100,
            letterSpacing: "1px",
            textTransform: "uppercase"
        },
        children: title
    });
};
const SectionLink = (param)=>/*#__PURE__*/ {
    let { name , href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Anchor */ .ee, {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        weight: "medium",
        css: {
            fontSize: 14,
            mt: 16,
            color: "white",
            zIndex: "9999"
        },
        children: name
    });
};
const homeLinks = [
    {
        name: "Home",
        href: "https://hunnys.io/"
    },
    {
        name: "About",
        href: "https://hunnys.io/about/"
    },
    {
        name: "Merch",
        href: "https://hunnys.io/shopselect/"
    }
];
const companySectionLinks = [
    {
        name: "Hunnys Closet",
        href: "https://closet.hunnys.io/"
    },
    {
        name: "Hunnys Lore",
        href: "https://hunnys.io/ourlore/"
    },
    {
        name: "Build Your Own Marketplace",
        href: "https://hunnys.io/bunnyu/launch-your-own-nft-marketplace/"
    }
];
const Footer = ()=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
        justify: "between",
        css: {
            borderTop: "1px solid $gray7",
            borderStyle: "solid",
            pt: "$5",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 36,
            "@bp600": {
                flexDirection: "row",
                gap: 0
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                css: {
                    gap: 80,
                    "@bp600": {
                        gap: 76
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionTitle, {
                                title: "Hunnys"
                            }),
                            homeLinks.map((props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionLink, {
                                    ...props
                                }, props.name))
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionTitle, {
                                title: "Explore"
                            }),
                            companySectionLinks.map((props)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionLink, {
                                    ...props
                                }, props.name))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                direction: "column",
                css: {
                    zIndex: "9999",
                    textAlign: "right",
                    alignItems: "flex-start",
                    "@bp600": {
                        alignItems: "flex-end"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SectionTitle, {
                        title: "Hunnys Community"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kC, {
                        css: {
                            gap: "$4",
                            mt: 16
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                href: "https://twitter.com/hunnysNFT",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    size: "xs",
                                    color: "gray3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                        color: "deepskyblue",
                                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faTwitter */ .mdU,
                                        width: 14,
                                        height: 14
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                href: "https://discord.gg/hunnys",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    size: "xs",
                                    color: "gray3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                        color: "cornflowerblue",
                                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faDiscord */ .omb,
                                        width: 14,
                                        height: 14
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                href: "https://instagram.com/hunnysNFT",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    size: "xs",
                                    color: "gray3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                        color: "orchid",
                                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faInstagram */ .Zzi,
                                        width: 14,
                                        height: 14
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                target: "_blank",
                                rel: "noopener noreferrer",
                                href: "https://youtube.com/@cryptostacys",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_primitives__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                                    size: "xs",
                                    color: "gray3",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_2__/* .FontAwesomeIcon */ .G, {
                                        color: "tomato",
                                        icon: _fortawesome_free_brands_svg_icons__WEBPACK_IMPORTED_MODULE_3__/* .faYoutube */ .opf,
                                        width: 14,
                                        height: 14
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ })

}]);